﻿import React, { useContext, useState, useRef, useEffect, Fragment} from 'react';
import { createFocusTrap } from 'focus-trap';
import { paramsToObject } from '../../../../../Resources/Scripts/_Shared/history'
import LockOverflowScroll from '../../../../../Resources/Scripts/_Shared/hooks/useLockBodyScroll'
import { CheckboxWithLabel } from '../../../../../Resources/Scripts/_Shared/elements/CheckboxWithLabel'
import { TwoColumnWrapper } from '../../../../../Resources/Scripts/_Shared/elements/ColumnWrapper'
import { facility } from '../../../BookingFlowPage/Scripts/Endpoints';
import { xor } from 'lodash';

const FiltersWidgetOverlay = ({ facilitySearchContext, setFacilitySearchContext }) => {
  LockOverflowScroll();

  const lang = {
    ...facilitySearchContext.localization.inputs,
    ...facilitySearchContext.localization.headings,
    ...facilitySearchContext.localization.filter
  };
  const backgroundRef = useRef(null);

  const [requestAnimation, setRequestAnimation] = useState(false);
  const [maxHeight, setMaxHeight] = useState({ maxHeight: '100%' });
  const [searchHits, setSearchHits] = useState(facilitySearchContext.filteredFacilities);

  const contextFiltersOpen = facilitySearchContext.filtersOpen;

  const [filterSelection, setFilterSelection] = useState(facilitySearchContext.filterSelection);
  const [currentServiceFilters, setCurrentServiceFilters] = useState([]);
  const [currentParkingSpaceTypes, setCurrentParkingSpaceTypes] = useState([]);
 
  const setSingleFilterSelection = (key, value, parkingSpaceType) => {
    const newFilterSelection = filterSelection;
    if (parkingSpaceType) newFilterSelection.ParkingSpaceTypeSelection[key] = value;
    else newFilterSelection[key] = value;

    if ((!filterSelection['STP'] && key === 'LTP' && value) || (filterSelection['LTP'] && key === 'STP' && !value)) {
      if (filterSelection['disabled']) newFilterSelection['disabled'] = false;
      if (filterSelection['electricChargingPoint']) newFilterSelection['electricChargingPoint'] = false;
    }
    setFilterSelection(newFilterSelection);
    setSearchHits(FilterFacilities(facilitySearchContext.allFacilities, newFilterSelection));
	}

  const closeHandler = (e) => {
		if (!e || e.target === backgroundRef.current) {
      setFacilitySearchContext({ ...facilitySearchContext, filtersOpen: false });
      window.removeEventListener('resize', initMaxHeight);
    }
  };

  function lowercaseKeys(obj) {    
    return Object
      .entries(obj)
      .reduce((carry, [key, value]) => {
        carry[key.toLowerCase()] = value;
  
        return carry;
      }, {});
  }

  const clearFiltersHandler = () => {
    //setFilterSelection({
    //  //AED: false,
    //  //ANPR: false,
    //  //bicycleParking: false,
    //  //buggyHire: false,
    //  //CCTV: false,
    //  //cambioCarSharing: false,
    //  //carRental: false,
    //  //carRepair: false,
    //  //carWash: false,
    //  //changingTable: false,
    //  //coinPayment: false,
    //  //creditCardPayment: false,
    //  //disabled: false,
    //  //disabledToilet: false,
    //  //drinkingWater: false,
    //  //electricChargingPoint: false,
    //  //elevator: false,
    //  //familyParkingSpots: false,
    //  //hearingAidLoop: false,
    //  //helpPoint: false,
    //  //hospital: false,
    //  //information: false,
    //  //jumpLeads: false,
    //  //mobilePayment: false,
    //  //mobilePhoneCoverage: false,
    //  //motorcycleParking: false,
    //  //newspaperMagazines: false,
    //  //pickUpPoint: false,
    //  //publicTransportation: false,
    //  //serviceCar: false,
    //  //shoePolisher: false,
    //  //shoppingTrolley: false,
    //  //surveillanceAtNight: false,
    //  //toilet: false,
    //  //tyrePump: false,
    //  //umbrellaHire: false,
    //  //vendingMachine: false,
    //  //WiFi: false,
    //  disabled: false,
    //  electricChargingPoint: false,
    //  indoor: false,
    //  outdoor: false,
    //  heated: false,
    //  maxVehicleHeight: false,
    //  LTP: false,
    //  STP: false
    //});
    const resetFilterSelection = { ParkingSpaceTypeSelection: {} }
    for (const [key] of Object.entries(filterSelection)) {
      if (key !== 'ParkingSpaceTypeSelection') resetFilterSelection[key] = false;
    }
    for (const [key] of Object.entries(filterSelection.ParkingSpaceTypeSelection)) resetFilterSelection.ParkingSpaceTypeSelection[key] = false;
    setFilterSelection(resetFilterSelection)
    setSearchHits(facilitySearchContext.allFacilities);
  };

  const applyFiltersHandler = () => {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.delete('f');
    urlParams.delete('p');
    const filters = [];
    const parkingFilters = [];
    for (const [key] of Object.entries(filterSelection)) { key !== 'ParkingSpaceTypeSelection' && filterSelection[key] && filters.push(key) };
    for (const [key] of Object.entries(filterSelection.ParkingSpaceTypeSelection)) { filterSelection.ParkingSpaceTypeSelection[key] && parkingFilters.push(key) };
    if (filters.length) urlParams.set('f', filters.join(','));
    if (parkingFilters.length) urlParams.set('p', parkingFilters.join(','));
    const newUrl = location.origin + window.location.pathname + '?' + urlParams.toString();
    history.pushState(paramsToObject(urlParams), document.title, newUrl);
    setFacilitySearchContext({ ...facilitySearchContext, filtersOpen: false, filterSelection, filteredFacilities: searchHits, updateMapBounds: true, updateMarkers: true });
  };

  useEffect(() => {
    if (facilitySearchContext.allFacilities.length === 0)
      return;

    const uniqueServices = [];
    const parkingSpaceTypes = [];
    const parkingSpaceTypesAsObject = {};
    const parkingSpaceTypeSelection = [];

    for (const [key] of Object.entries(filterSelection.ParkingSpaceTypeSelection)) { filterSelection.ParkingSpaceTypeSelection[key] && parkingSpaceTypeSelection.push(key) };

    for (let i = 0; i < facilitySearchContext.allFacilities.length; i++) {
      const singleFacility = facilitySearchContext.allFacilities[i];
      const facilityServices = singleFacility.Services;
      let singleParkingSpaceTypes = singleFacility.ParkingZones.map(zone => zone.Pmcs && zone.Pmcs.map(pmc => pmc.ParkingSpaceType))[0];
      singleParkingSpaceTypes = singleParkingSpaceTypes ? singleParkingSpaceTypes.filter(Boolean) : [];
      //singleParkingSpaceTypes = singleParkingSpaceTypes.length > 0 && Array.from(new Set(singleParkingSpaceTypes));
      const facilityInfo = {
        Indoor: singleFacility.Indoor,
        Outdoor: !singleFacility.Indoor,
        LTP: singleFacility.HasLtp,
        STP: singleFacility.HasStp,
        ...singleFacility.Info
      };

      for (let x = 0; x < facilityServices.length; x++) {
        var singleService = facilityServices[x];
        if (uniqueServices.filter(service => service === singleService).length === 0)
          uniqueServices.push(singleService);
      }

      for (const [key] of Object.entries(facilityInfo)) {
        if (facilityInfo[key] && key !== 'type' && !uniqueServices.includes(key)) uniqueServices.push(key);
      }
      if (singleParkingSpaceTypes) parkingSpaceTypes.push(...singleParkingSpaceTypes)
    }
    if (parkingSpaceTypes && parkingSpaceTypes.length) Array.from(new Set(parkingSpaceTypes.filter(Boolean).flat())).forEach(type => parkingSpaceTypesAsObject[type] = filterSelection.ParkingSpaceTypeSelection[type] ? filterSelection.ParkingSpaceTypeSelection[type] : false)

    setFilterSelection({ ...filterSelection, ParkingSpaceTypeSelection: { ...filterSelection.ParkingSpaceTypeSelection, ...parkingSpaceTypesAsObject } })
    setCurrentServiceFilters(uniqueServices);
    setCurrentParkingSpaceTypes(Array.from(new Set([...parkingSpaceTypeSelection, ...parkingSpaceTypes.flat()])));

  }, [facilitySearchContext.allFacilities])

  const isFilterVisible = filterName => currentServiceFilters.filter(filter => filter === filterName).length > 0 || currentParkingSpaceTypes.filter(filter => filter === filterName).length > 0;
  const initMaxHeight = (e) => {
    if (!requestAnimation) {
      window.requestAnimationFrame(() => {
        if(contextFiltersOpen)
          setMaxHeight({ maxHeight: `${window.innerHeight}px` });
        else
          setMaxHeight(null);

        setRequestAnimation(false);
      });
    }

    setRequestAnimation(false);
  };

  useEffect(() => {
		if (contextFiltersOpen)
      window.addEventListener('resize', initMaxHeight);
		else
      window.removeEventListener('resize', initMaxHeight);

    return () => window.removeEventListener('resize', initMaxHeight);
  }, [contextFiltersOpen])

  useEffect(() => {
		//Focus trap

		const overlayFocusTrap = createFocusTrap(backgroundRef.current);
		overlayFocusTrap.activate();

		return () => { overlayFocusTrap.deactivate(); }
  }, [])

  return (
    <div className="facilitysearchpage__filters" ref={backgroundRef} onClick={(e) => closeHandler(e)}>
      <div className="facilitysearchpage__filters__inner" style={maxHeight}>
        <header>
          {lang.filteroverlay}
          <button onClick={() => closeHandler(null)} className="facilitysearchpage__filters--close">{lang.close}</button>
          <ClearFilters text={lang.buttons.clearshort} onClick={clearFiltersHandler} />
        </header>
        <main>
          {/*<SliderWithLabel text="Max distance from specified adress" value={filterSelection.distance} setValue={(value) => setSingleFilterSelection('distance', value)} tooltip="km" />
          <Divider />*/}
          <h3>{lang.headings.services}</h3>
          <TwoColumnWrapper>
            {/*{ (isFilterVisible('AED') || filterSelection.AED) && <CheckboxWithLabel text={lang.services.aed} value={filterSelection.AED} setValue={(value) => setSingleFilterSelection('AED', value)} /> }*/}
            {/*{ (isFilterVisible('ANPR') || filterSelection.ANPR) && <CheckboxWithLabel text={lang.services.anpr} value={filterSelection.ANPR} setValue={(value) => setSingleFilterSelection('ANPR', value)} /> }*/}
            {/*{ (isFilterVisible('bicycleParking') || filterSelection.bicycleParking) && <CheckboxWithLabel text={lang.services.bicycleparking} value={filterSelection.bicycleParking} setValue={(value) => setSingleFilterSelection('bicycleParking', value)} /> }*/}
            {/*{ (isFilterVisible('buggyHire') || filterSelection.buggyHire) && <CheckboxWithLabel text={lang.services.buggyhire} value={filterSelection.buggyHire} setValue={(value) => setSingleFilterSelection('buggyHire', value)} /> }*/}
            {/*{ (isFilterVisible('CCTV') || filterSelection.CCTV) && <CheckboxWithLabel text={lang.services.cctv} value={filterSelection.CCTV} setValue={(value) => setSingleFilterSelection('CCTV', value)} /> }*/}
            {/*{ (isFilterVisible('cambioCarSharing') || filterSelection.cambioCarSharing) && <CheckboxWithLabel text={lang.services.cambiocarsharing} value={filterSelection.cambioCarSharing} setValue={(value) => setSingleFilterSelection('cambioCarSharing', value)} /> }*/}
            {/*{ (isFilterVisible('carRental') || filterSelection.carRental) && <CheckboxWithLabel text={lang.services.carrental} value={filterSelection.carRental} setValue={(value) => setSingleFilterSelection('carRental', value)} /> }*/}
            {/*{ (isFilterVisible('carRepair') || filterSelection.carRepair) && <CheckboxWithLabel text={lang.services.carrepair} value={filterSelection.carRepair} setValue={(value) => setSingleFilterSelection('carRepair', value)} /> }*/}
            {/*{ (isFilterVisible('carWash') || filterSelection.carWash) && <CheckboxWithLabel text={lang.services.carwash} value={filterSelection.carWash} setValue={(value) => setSingleFilterSelection('carWash', value)} /> }*/}
            {/*{ (isFilterVisible('changingTable') || filterSelection.changingTable) && <CheckboxWithLabel text={lang.services.changingtable} value={filterSelection.changingTable} setValue={(value) => setSingleFilterSelection('changingTable', value)} /> }*/}
            {/*{ (isFilterVisible('coinPayment') || filterSelection.coinPayment) && <CheckboxWithLabel text={lang.services.coinpayment} value={filterSelection.coinPayment} setValue={(value) => setSingleFilterSelection('coinPayment', value)} /> }*/}
            {/*{ (isFilterVisible('creditCardPayment') || filterSelection.creditCardPayment) && <CheckboxWithLabel text={lang.services.creditcardpayment} value={filterSelection.creditCardPayment} setValue={(value) => setSingleFilterSelection('creditCardPayment', value)} /> }*/}
            {/*{ (isFilterVisible('disabled') || filterSelection.disabled) && <CheckboxWithLabel text={lang.services.disabled} value={filterSelection.disabled} setValue={(value) => setSingleFilterSelection('disabled', value)} /> }*/}
            {/*{ (isFilterVisible('disabledToilet') || filterSelection.disabledToilet) && <CheckboxWithLabel text={lang.services.disabledtoilet} value={filterSelection.disabledToilet} setValue={(value) => setSingleFilterSelection('disabledToilet', value)} /> }*/}
            {/*{ (isFilterVisible('drinkingWater') || filterSelection.drinkingWater) && <CheckboxWithLabel text={lang.services.drinkingwater} value={filterSelection.drinkingWater} setValue={(value) => setSingleFilterSelection('drinkingWater', value)} /> }*/}
            {/*{ (isFilterVisible('electricChargingPoint') || filterSelection.electricChargingPoint) && <CheckboxWithLabel text={lang.services.electricchargingpoint} value={filterSelection.electricChargingPoint} setValue={(value) => setSingleFilterSelection('electricChargingPoint', value)} /> }*/}
            {/*{ (isFilterVisible('elevator') || filterSelection.elevator) && <CheckboxWithLabel text={lang.services.elevator} value={filterSelection.elevator} setValue={(value) => setSingleFilterSelection('elevator', value)} /> }*/}
            {/*{ (isFilterVisible('familyParkingSpots') || filterSelection.familyParkingSpots) && <CheckboxWithLabel text={lang.services.familyparkingspots} value={filterSelection.familyParkingSpots} setValue={(value) => setSingleFilterSelection('familyParkingSpots', value)} /> }*/}
            {/*{ (isFilterVisible('hearingAidLoop') || filterSelection.hearingAidLoop) && <CheckboxWithLabel text={lang.services.hearingaidloop} value={filterSelection.hearingAidLoop} setValue={(value) => setSingleFilterSelection('hearingAidLoop', value)} /> }*/}
            {/*{ (isFilterVisible('helpPoint') || filterSelection.helpPoint) && <CheckboxWithLabel text={lang.services.helppoint} value={filterSelection.helpPoint} setValue={(value) => setSingleFilterSelection('helpPoint', value)} /> }*/}
            {/*{ (isFilterVisible('hospital') || filterSelection.hospital) && <CheckboxWithLabel text={lang.services.hospital} value={filterSelection.hospital} setValue={(value) => setSingleFilterSelection('hospital', value)} /> }*/}
            {/*{ (isFilterVisible('information') || filterSelection.information) && <CheckboxWithLabel text={lang.services.information} value={filterSelection.information} setValue={(value) => setSingleFilterSelection('information', value)} /> }*/}
            {/*{ (isFilterVisible('jumpLeads') || filterSelection.jumpLeads) && <CheckboxWithLabel text={lang.services.jumpleads} value={filterSelection.jumpLeads} setValue={(value) => setSingleFilterSelection('jumpLeads', value)} /> }*/}
            {/*{ (isFilterVisible('mobilePayment') || filterSelection.mobilePayment) && <CheckboxWithLabel text={lang.services.mobilepayment} value={filterSelection.mobilePayment} setValue={(value) => setSingleFilterSelection('mobilePayment', value)} /> }*/}
            {/*{ (isFilterVisible('mobilePhoneCoverage') || filterSelection.mobilePhoneCoverage) && <CheckboxWithLabel text={lang.services.mobilephonecoverage} value={filterSelection.mobilePhoneCoverage} setValue={(value) => setSingleFilterSelection('mobilePhoneCoverage', value)} /> }*/}
            {/*{ (isFilterVisible('motorcycleParking') || filterSelection.motorcycleParking) && <CheckboxWithLabel text={lang.services.motorcycleparking} value={filterSelection.motorcycleParking} setValue={(value) => setSingleFilterSelection('motorcycleParking', value)} /> }*/}
            {/*{ (isFilterVisible('newspaperMagazines') || filterSelection.newspaperMagazines) && <CheckboxWithLabel text={lang.services.newspapermagazines} value={filterSelection.newspaperMagazines} setValue={(value) => setSingleFilterSelection('newspaperMagazines', value)} /> }*/}
            {/*{ (isFilterVisible('pickUpPoint') || filterSelection.pickUpPoint) && <CheckboxWithLabel text={lang.services.pickuppoint} value={filterSelection.pickUpPoint} setValue={(value) => setSingleFilterSelection('pickUpPoint', value)} /> }*/}
            {/*{ (isFilterVisible('publicTransportation') || filterSelection.publicTransportation) && <CheckboxWithLabel text={lang.services.publictransportation} value={filterSelection.publicTransportation} setValue={(value) => setSingleFilterSelection('publicTransportation', value)} /> }*/}
            {/*{ (isFilterVisible('serviceCar') || filterSelection.serviceCar) && <CheckboxWithLabel text={lang.services.servicecar} value={filterSelection.serviceCar} setValue={(value) => setSingleFilterSelection('serviceCar', value)} /> }*/}
            {/*{ (isFilterVisible('shoePolisher') || filterSelection.shoePolisher) && <CheckboxWithLabel text={lang.services.shoepolisher} value={filterSelection.shoePolisher} setValue={(value) => setSingleFilterSelection('shoePolisher', value)} /> }*/}
            {/*{ (isFilterVisible('shoppingTrolley') || filterSelection.shoppingTrolley) && <CheckboxWithLabel text={lang.services.shoppingtrolley} value={filterSelection.shoppingTrolley} setValue={(value) => setSingleFilterSelection('shoppingTrolley', value)} /> }*/}
            {/*{ (isFilterVisible('surveillanceAtNight') || filterSelection.surveillanceAtNight) && <CheckboxWithLabel text={lang.services.surveillanceatnight} value={filterSelection.surveillanceAtNight} setValue={(value) => setSingleFilterSelection('surveillanceAtNight', value)} /> }*/}
            {/*{ (isFilterVisible('toilet') || filterSelection.toilet) && <CheckboxWithLabel text={lang.services.toilet} value={filterSelection.toilet} setValue={(value) => setSingleFilterSelection('toilet', value)} /> }*/}
            {/*{ (isFilterVisible('tyrePump') || filterSelection.tyrePump) && <CheckboxWithLabel text={lang.services.tyrepump} value={filterSelection.tyrePump} setValue={(value) => setSingleFilterSelection('tyrePump', value)} /> }*/}
            {/*{ (isFilterVisible('umbrellaHire') || filterSelection.umbrellaHire) && <CheckboxWithLabel text={lang.services.umbrellahire} value={filterSelection.umbrellaHire} setValue={(value) => setSingleFilterSelection('umbrellaHire', value)} /> }*/}
            {/*{ (isFilterVisible('vendingMachine') || filterSelection.vendingMachine) && <CheckboxWithLabel text={lang.services.vendingmachine} value={filterSelection.vendingMachine} setValue={(value) => setSingleFilterSelection('vendingMachine', value)} /> }*/}
            {/*{(isFilterVisible('WiFi') || filterSelection.WiFi) && <CheckboxWithLabel text={lang.services.wifi} value={filterSelection.WiFi} setValue={(value) => setSingleFilterSelection('WiFi', value)} />}*/}
            {(isFilterVisible('LTP') || filterSelection.LTP) && <CheckboxWithLabel text={lang.info.LTP} value={filterSelection.LTP} setValue={(value) => setSingleFilterSelection('LTP', value)} />}
            {(isFilterVisible('STP') || filterSelection.STP) && <CheckboxWithLabel text={lang.info.STP} value={filterSelection.STP} setValue={(value) => setSingleFilterSelection('STP', value)} />}
            {(isFilterVisible('Indoor') || filterSelection.Indoor) && <CheckboxWithLabel text={lang.info.indoor} value={filterSelection.Indoor} setValue={(value) => setSingleFilterSelection('Indoor', value)} />}
            {(isFilterVisible('Outdoor') || filterSelection.Outdoor) && <CheckboxWithLabel text={lang.info.outdoor} value={filterSelection.Outdoor} setValue={(value) => setSingleFilterSelection('Outdoor', value)} />}
            {(isFilterVisible('Heated') || filterSelection.Heated) && <CheckboxWithLabel text={lang.info.heated} value={filterSelection.Heated} setValue={(value) => setSingleFilterSelection('Heated', value)} />}
            {(isFilterVisible('MaxVehicleHeight') || filterSelection.MaxVehicleHeight) && <CheckboxWithLabel text={lang.info.maxVehicleHeight} value={filterSelection.MaxVehicleHeight} setValue={(value) => setSingleFilterSelection('MaxVehicleHeight', value)} />}           
            {(isFilterVisible('disabled') || filterSelection.disabled) && <CheckboxWithLabel disabled={!filterSelection.disabled && filterSelection.LTP && !filterSelection.STP} text={lang.services.disabled + '*'} value={filterSelection.disabled} setValue={(value) => setSingleFilterSelection('disabled', value)} />}
            {(isFilterVisible('electricChargingPoint') || filterSelection.electricChargingPoint) && <CheckboxWithLabel disabled={!filterSelection.electricChargingPoint && filterSelection.LTP && !filterSelection.STP} text={lang.services.electricchargingpoint + '*'} value={filterSelection.electricChargingPoint} setValue={(value) => setSingleFilterSelection('electricChargingPoint', value)} />}
          </TwoColumnWrapper>
          {((isFilterVisible('electricChargingPoint') || filterSelection.electricChargingPoint) || (isFilterVisible('disabled') || filterSelection.disabled)) && <p>*{lang.services.onlySTP}</p>}
          {currentParkingSpaceTypes && currentParkingSpaceTypes.length > 0 && <Fragment>
            <h3>{lang.headings.parkingspacetype}</h3>
            <TwoColumnWrapper>
              {currentParkingSpaceTypes.map(type => (isFilterVisible(type) || filterSelection.ParkingSpaceTypeSelection[type]) && (
                <CheckboxWithLabel key={type} text={type} value={filterSelection.ParkingSpaceTypeSelection[type]} setValue={(value) => setSingleFilterSelection(type, value, true)} />)
              )}
            </TwoColumnWrapper>
          </Fragment>
          }
          {/*<ToggleContentWrapper text="Show all services">
            <TwoColumnWrapper>
              <CheckboxWithLabel text="Extra service 1" value={filterSelection.extraService1} setValue={(value) => setSingleFilterSelection('extraService1', value)} />
              <CheckboxWithLabel text="Extra service 2" value={filterSelection.extraService2} setValue={(value) => setSingleFilterSelection('extraService2', value)} />
            </TwoColumnWrapper>
          </ToggleContentWrapper>
          <Divider />
          <SwitchWithLabel text="Online bookable" value={filterSelection.onlineBookable} setValue={(value) => setSingleFilterSelection('onlineBookable', value)} />
          <Divider />
          <SwitchWithLabel text="Long term rent" value={filterSelection.longTermRent} setValue={(value) => setSingleFilterSelection('longTermRent', value)} />
          <TwoColumnWrapper>
            <CheckboxWithLabel text="7x24" value={filterSelection.product7x24} setValue={(value) => setSingleFilterSelection('product7x24', value)} />
            <CheckboxWithLabel text="5x24" value={filterSelection.product5x24} setValue={(value) => setSingleFilterSelection('product5x24', value)} />
            <CheckboxWithLabel text="Office hours" value={filterSelection.productOfficeHours} setValue={(value) => setSingleFilterSelection('productOfficeHours', value)} />
            <CheckboxWithLabel text="Weekend" value={filterSelection.productWeekend} setValue={(value) => setSingleFilterSelection('productWeekend', value)} />
          </TwoColumnWrapper>*/}
        </main>
        <footer>
          <ClearFilters text={lang.buttons.clearlong} onClick={clearFiltersHandler} />
          <button onClick={applyFiltersHandler} className="facilitysearchpage__filters--apply" disabled={searchHits.length === 0}>{lang.buttons.multiple.replace('{0}', searchHits.length)}</button>
        </footer>
      </div>
    </div>
  )
}

const ClearFilters = (props) => {
  return <button onClick={() => props.onClick()} className="facilitysearchpage__filters--clear">{props.text}</button>
}

const FiltersWidget = ({ facilitySearchContext, setFacilitySearchContext }) => {
  if (!facilitySearchContext.filtersOpen)
    return null;

  return <FiltersWidgetOverlay facilitySearchContext={facilitySearchContext} setFacilitySearchContext={setFacilitySearchContext} />
}

export const FilterFacilities = (allFacilities, filterSelection) => {
  const flatFilterSelection = [];
  const matchingFacilities = [];

  for (const [key, value] of Object.entries(filterSelection)) {
    if (value && key !== 'Distance' && key !== 'ParkingSpaceTypeSelection')
      flatFilterSelection.push(key);
  }
  if (filterSelection.ParkingSpaceTypeSelection) {
    for (const [key, value] of Object.entries(filterSelection.ParkingSpaceTypeSelection)) {
    if (value)
      flatFilterSelection.push(key);
    }
  }

  for (let i = 0; i < allFacilities.length; i++) {
    const singleFacility = allFacilities[i];
    const singleFacilityServices = singleFacility.Services ?? [];
    let singleParkingSpaceTypes = singleFacility.ParkingZones.map(zone => zone.Pmcs && zone.Pmcs.map(pmc => pmc.ParkingSpaceType))[0];
    singleParkingSpaceTypes = singleParkingSpaceTypes ? singleParkingSpaceTypes.filter(Boolean) : [];
    singleParkingSpaceTypes = singleParkingSpaceTypes.length > 0 && Array.from(new Set(singleParkingSpaceTypes));

    const parkingSpaceTypesAsObject = {};

    if (singleParkingSpaceTypes && singleParkingSpaceTypes.length) Array.from(new Set(singleParkingSpaceTypes.filter(Boolean).flat())).forEach(type => parkingSpaceTypesAsObject[type] = true)

    const singleFacilityInfo = {
      Indoor: singleFacility.Indoor,
      Outdoor: !singleFacility.Indoor,
      LTP: singleFacility.HasLtp,
      STP: singleFacility.HasStp,
      ...singleFacility.Info,
      ...parkingSpaceTypesAsObject
    };

    const matchCount = [
      ...singleFacilityServices.filter(service => flatFilterSelection.includes(service)),
      ...flatFilterSelection.filter(filter => singleFacilityInfo[filter] && ((filter === 'MaxVehicleHeight' && singleFacilityInfo[filter] > 200) || filter !== 'MaxVehicleHeight'))
    ];

    if (flatFilterSelection.length === Array.from(new Set(matchCount)).length)
      matchingFacilities.push(singleFacility);
  }

  return matchingFacilities;

}
export default FiltersWidget;
